import { z } from "zod";

export const requestToJoinSchema = z.object({
  restaurantName: z.string().trim().min(1, "Restaurant name is required."),
  contactName: z.string().trim().min(1, "Contact name is required."),
  email: z.string().trim().min(1, "Email is required.").email("Enter a valid email address."),
  phone: z.string().trim().regex(/^\d*$/, "Phone must contain digits only."),
  notes: z.string(),
});
